import { NgModule } from '@angular/core';
import { CheckoutStoreModule } from './store/delivery-store.module';

@NgModule({
  imports: [CheckoutStoreModule],
})
export class DeliveryDataAccessModule {}
